import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R from 'ramda'

const d = { deep: true }

export const CenterRedux = createActions(
  {
    setActiveCenterId: ['id'],
    setActiveStudentId: ['id'],
    updateVirtualCheckin: ['data'],
    getCentersByContractRequest: ['contractId'],
    getCentersByContractSuccess: ['data'],
    getCentersByContractFailed: ['error'],
  },
  {
    prefix: 'CENTERS_',
    defaultActions: {
      get: true,
      getOne: true,
    },
  },
)

const { Types, Creators } = CenterRedux
export const CenterTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  activeCenterId: 0,
  activeStudentId: 0,
}, {
  get: true,
  getOne: true,
})

/* ------------- Reducers ------------- */

// ----------------------------ACTIVES-------------------------------
const setActiveCenterId = (state, { id }) => state.merge({ activeCenterId: id }, d)
const setActiveStudentId = (state, { id }) => state.merge({ activeStudentId: id }, d)

const updateVirtualCheckin = (state, { data }) => {
  if (data.status === 'checked in') {
    const newCenters = R.clone(state.get.results)
    const activeCenterIndex = R.findIndex(R.propEq('id', state.activeCenterId))(newCenters)

    const activeStudentIndex = R.findIndex(R.propEq('id', data.data.latest_health_check.student_id))(newCenters[activeCenterIndex].students)

    const student = newCenters[activeCenterIndex].students[activeStudentIndex]
    let checkinInfo = ''
    if (data.destination === 'Advenio') {
      checkinInfo = { checkin: { id: data.data.id, status: 'Advenio' }, temperature: data.data.latest_health_check.temperature }
    } else if (data.destination === "Nurse's Room") {
      checkinInfo = { checkin: { id: data.data.id, status: "Nurse's Room" }, temperature: data.data.latest_health_check.temperature }
    } else if (data.destination === 'Virtual Center - Advenio') {
      checkinInfo = { checkin: { id: data.data.id, status: 'Advenio', is_virtual_center: true }, temperature: data.data.latest_health_check.temperature }
    } else if (data.destination === "Virtual Center - Nurse's Room") {
      checkinInfo = { checkin: { id: data.data.id, status: "Nurse's Room", is_virtual_center: true }, temperature: data.data.latest_health_check.temperature }
    }

    const studentUpdated = R.merge(student, checkinInfo)
    newCenters[activeCenterIndex].students[activeStudentIndex] = studentUpdated

    return state.merge({ get: { fetching: false, results: newCenters } }, d)
  } else if (data.status === 'sent home') {
    const newCenters = R.clone(state.centers.get.results)
    const activeCenterIndex = R.findIndex(R.propEq('id', state.activeCenterId))(newCenters)
    const activeStudentIndex = R.findIndex(R.propEq('id', data.data.student_id))(newCenters[activeCenterIndex].students)

    const student = newCenters[activeCenterIndex].students[activeStudentIndex]
    const checkinInfo = { checkin: { id: null, status: 'Home' }, temperature: data.data.temperature }

    const studentUpdated = R.merge(student, checkinInfo)

    newCenters[activeCenterIndex].students[activeStudentIndex] = studentUpdated

    return state.merge({ get: { fetching: false, results: newCenters } }, d)
  }
  return state
}


const getCentersByContractRequest = state =>
  state.merge({ get: { fetching: true, error: null } }, d)

const getCentersByContractSuccess = (state, { data }) =>
  state.merge({ get: { fetching: false, error: null, results:data } }, d)

const getCentersByContractFailed = (state, { error }) =>
  state.merge({ get: { fetching: false, error } }, d)


// --------------------------MAIN REDUCER ------------------------------------------
export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.setActiveCenterId]: setActiveCenterId,
    [Types.updateVirtualCheckin]: updateVirtualCheckin,
    [Types.getCentersByContractRequest]: getCentersByContractRequest,
    [Types.getCentersByContractSuccess]: getCentersByContractSuccess,
    [Types.getCentersByContractFailed]: getCentersByContractFailed,
  },
  {
    defaultActions: {
      get: true,
      getOne: true,
    },
    Types,
  },
)

/* ------------- Selectors ------------- */

const activeCenter = (state) => {
  const { activeCenterId } = state.centers
  const centers = state.centers.get.results
  const activeCenterIndex = R.findIndex(R.propEq('id', activeCenterId))(centers)
  return centers[activeCenterIndex]
}

const activeStudent = (state) => {
  const centers = state.centers.get.results
  const { activeStudentId, activeCenterId } = state.centers
  const activeCenterIndex = R.findIndex(R.propEq('id', activeCenterId))(centers)
  if (centers[activeCenterIndex]) {
    const activeStudentIndex = R.findIndex(R.propEq('id', activeStudentId))(centers[activeCenterIndex].students)
    return centers[activeCenterIndex].students[activeStudentIndex]
  }
  return {}
}

const getCenterById = (centerId, state) => {
  if (state.centers.get.results.length > 0) {
    const centers = state.centers.get.results
    const activeCenterIndex = R.findIndex(R.propEq('id', centerId))(centers)
    return centers[activeCenterIndex]
  }
  return {}
}
export const Selectors = {
  activeCenter,
  activeStudent,
  getCenterById,
}



// WEBPACK FOOTER //
// ./src/Data/Redux/CenterRedux.js